<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="640px" scrollable>
      <v-card class="grid">
        <!-- close -->
        <v-toolbar elevation="0" class="cartPlanText textType--text">
          <span v-if="moreDetails">
            <v-btn icon @click="backToMain">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span>{{
              $t('message.pages.customizeModal.thisCycleDetails')
            }}</span>
          </span>
          <span v-else>
            {{ $t('message.paymentDetails') }}
          </span>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- steps -->
        <v-card-text
          class="my-0 py-0 pl-6 pr-8"
          :class="moreDetails ? 'px-5' : 'px-10'"
          style="height: 450px"
        >
          <v-row no-gutters v-if="moreDetails">
            <v-col cols="12" class="columnTitle mb-2">
              <v-row no-gutters>
                <v-col cols="10">
                  <span>ITEM</span>
                </v-col>
                <v-col cols="2">
                  <v-row no-gutters justify="end">
                    <span>{{ $t('message.pages.customizeModal.price') }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-row
              no-gutters
              v-for="(prorateObject, i) in prorateObjects"
              :key="i"
            >
              <v-row
                no-gutters
                class="pa-2 text--month-listing border-bottom--gray"
                :class="{
                  'text--month-listing--dark': $vuetify.theme.dark,
                }"
              >
                <v-col cols="12">
                  <span class="text-caption text--secondary">
                    {{ timeConverter(prorateObject.start) }}
                    - {{ timeConverter(prorateObject.end) }},
                    {{ new Date(prorateObject.end * 1000).getFullYear() }}
                    <b
                      v-if="getProhataLabel(prorateObject)"
                      class="text--current-month"
                    >
                      <template
                        v-if="getProhataLabel(prorateObject) === 'current'"
                      >
                        ({{
                          $t(
                            'message.pages.customizeModal.proportionalCurrentMonth'
                          )
                        }})
                      </template>
                      <template
                        v-if="getProhataLabel(prorateObject) === 'next'"
                      >
                        ({{
                          $t(
                            'message.pages.customizeModal.proportionalNextMonth'
                          )
                        }})
                      </template>
                    </b>
                  </span>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                v-for="(objLine, i) in prorateObject.objects"
                :key="i"
                style="width: 100%; line-height: 15px !important"
                class="pl-2 pr-0 py-4 border-bottom--gray"
              >
                <v-row no-gutters>
                  <v-col>
                    <span
                      class="text-caption text--primary"
                      style="line-height: 15px !important"
                      >{{ replaceKeywords(objLine.description) }}
                    </span>
                  </v-col>
                  <v-col cols="2" class="d-flex justify-end">
                    <span class="text-caption"
                      ><b>
                        {{
                          (objLine.amount / 100).toLocaleString(
                            currencyLocale,
                            { style: 'currency', currency: currency }
                          )
                        }}
                      </b></span
                    >
                  </v-col>
                </v-row>
              </v-row>
            </v-row>
            <v-col cols="12" class="mt-4 mb-8">
              <v-row no-gutters>
                <v-col cols="10">
                  <span
                    ><b>{{
                      $t('message.pages.customizeModal.totalToNext')
                    }}</b></span
                  >
                </v-col>
                <v-col cols="2" v-if="prorateData && prorateData.amount_due">
                  <v-row no-gutters justify="end">
                    <span
                      ><b>{{
                        (prorateData.amount_due / 100).toLocaleString(
                          currencyLocale,
                          {
                            style: 'currency',
                            currency: currency,
                          }
                        )
                      }}</b></span
                    >
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="mx-4" v-else-if="withoutProrateLines.length">
            <v-col cols="12" class="mx-auto py-2 mt-3">
              <v-row no-gutters>
                <v-col cols="10">
                  <span class="cartSubPricesText textType--text"> ITEM </span>
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  <span class="cartSubPricesText textType--text">{{
                    $t('message.pages.customizeModal.price').toUpperCase()
                  }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-row
              no-gutters
              v-for="(objLine, i) in withoutProrateLines"
              :key="i"
              style="width: 100%; line-height: 15px !important"
              class="py-2"
            >
              <v-row no-gutters>
                <v-col class="pr-1">
                  <span
                    class="customizeItemsText textType2--text"
                    style="line-height: 15px !important"
                    >{{ replaceKeywords(objLine.description) }}
                  </span>
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  <span
                    class="customizeItemsText textType2--text"
                    style="white-space: nowrap"
                  >
                    {{
                      (objLine.amount / 100).toLocaleString(currencyLocale, {
                        style: 'currency',
                        currency: currency,
                      })
                    }}
                  </span>
                </v-col>
              </v-row>
            </v-row>
          </v-row>
          <v-col cols="12" class="py-3" v-if="!moreDetails">
            <v-divider />
          </v-col>
          <v-row no-gutters class="mx-4" v-if="!moreDetails">
            <v-col
              cols="12"
              class="mx-auto mb-1"
              v-if="
                (prorateResponse.subtotal && prorateDiscount) ||
                (prorateResponse.subtotal && prorateResponse.referral_balance)
              "
            >
              <v-row no-gutters justify="space-between">
                <span class="customizeItemsText textType2--text">
                  Subtotal
                </span>
                <span class="customizeItemsText textType2--text"
                  >{{
                    (prorateResponse.subtotal / 100).toLocaleString(
                      currencyLocale,
                      { style: 'currency', currency: currency }
                    )
                  }}
                </span>
              </v-row>
            </v-col>
            <template v-if="prorateDiscount">
              <v-col cols="12" class="mx-auto my-1">
                <v-row
                  no-gutters
                  v-if="prorateDiscount.coupon.amount_off"
                  justify="space-between"
                >
                  <span class="customizeItemsText textType2--text">{{
                    `${prorateDiscount.coupon.name} (${(
                      prorateDiscount.coupon.amount_off / 100
                    ).toLocaleString(currencyLocale, {
                      style: 'currency',
                      currency: currency,
                    })} off)`
                  }}</span>
                  <span class="customizeItemsText textType2--text"
                    >-{{
                      (prorateDiscount.amount / 100).toLocaleString(
                        currencyLocale,
                        { style: 'currency', currency: currency }
                      )
                    }}
                  </span>
                </v-row>
                <v-row no-gutters v-else justify="space-between">
                  <span class="customizeItemsText textType2--text">{{
                    `${prorateDiscount.coupon.name} (${prorateDiscount.coupon.percent_off}% off)`
                  }}</span>
                  <span class="customizeItemsText textType2--text"
                    >-{{
                      (prorateDiscount.amount / 100).toLocaleString(
                        currencyLocale,
                        { style: 'currency', currency: currency }
                      )
                    }}</span
                  >
                </v-row>
              </v-col>
            </template>
            <v-col
              cols="12"
              class="mx-auto my-1"
              v-if="prorateResponse.referral_balance"
            >
              <v-row no-gutters justify="space-between">
                <span class="customizeItemsText textType2--text">{{
                  $t('message.pages.customizeModal.referralBalance')
                }}</span>
                <span class="customizeItemsText textType2--text"
                  >-{{
                    (prorateResponse.referral_balance / 100).toLocaleString(
                      currencyLocale,
                      { style: 'currency', currency: currency }
                    )
                  }}
                </span>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              class="mx-auto my-1"
              v-if="
                prorateResponse.starting_balance &&
                prorateResponse.starting_balance !=
                  `-${prorateResponse.referral_balance}`
              "
            >
              <v-row no-gutters justify="space-between">
                <v-col class="d-flex justify-end">
                  <span class="text-caption grey--text">{{
                    $t('message.pages.customizeModal.appliedDescount')
                  }}</span>
                  <span
                    class="text-caption d-flex justify-end"
                    style="width: 110px"
                    ><b>{{
                      (prorateResponse.starting_balance / 100).toLocaleString(
                        currencyLocale,
                        {
                          style: 'currency',
                          currency: currency,
                        }
                      )
                    }}</b></span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="prorateDiscount || prorateResponse.ending_balance"
              cols="12"
              class="mx-auto my-1"
            >
              <v-row no-gutters justify="space-between">
                <span class="customizeItemsText textType2--text"> Total </span>
                <span
                  v-if="prorateResponse.total && ending_balance >= 1"
                  class="customizeItemsText textType2--text"
                >
                  {{
                    (prorateResponse.ending_balance / 100).toLocaleString(
                      currencyLocale,
                      {
                        style: 'currency',
                        currency: currency,
                      }
                    )
                  }}
                </span>
                <span v-else class="customizeItemsText textType2--text">
                  {{
                    (0).toLocaleString(currencyLocale, {
                      style: 'currency',
                      currency: currency,
                    })
                  }}
                </span>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              class="mx-auto my-1"
              v-if="prorateResponse.amount_due"
            >
              <v-row no-gutters justify="space-between">
                <span class="customizeItemsText textType2--text">
                  {{ $t('message.pages.customizeModal.finalValue') }}
                </span>
                <span class="customizeItemsText textType2--text"
                  >{{
                    sumCycleValues(withoutProrateLines).toLocaleString(
                      currencyLocale,
                      {
                        style: 'currency',
                        currency: currency,
                      }
                    )
                  }}
                </span>
              </v-row>
            </v-col>
          </v-row>
          <v-col cols="12" class="mt-6" v-if="!moreDetails">
            <v-card width="100%" class="elevation-0 px-6" color="newBackground">
              <v-card
                v-if="prorateObjects.length > 1"
                height="79px"
                width="100%"
                color="newBackground"
                flat
              >
                <v-row
                  no-gutters
                  justify="center"
                  align="center"
                  class="fill-height"
                >
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="7">
                        <span class="cartBenefitsText typeText2--text mr-2">
                          <b>{{
                            $t('message.pages.customizeModal.actualCycle')
                          }}</b>
                        </span>
                        <span
                          class="customizeItemsText primary--text"
                          style="cursor: pointer"
                          @click="handleMoreDetails"
                        >
                          <b
                            >+
                            {{ $t('message.pages.customizeModal.details') }}</b
                          >
                        </span>
                      </v-col>
                      <v-col cols="5" class="d-flex justify-end">
                        <span class="cartBenefitsText primary--text">
                          {{
                            (prorateResponse.amount_due / 100).toLocaleString(
                              currencyLocale,
                              {
                                style: 'currency',
                                currency: currency,
                              }
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col cols="7">
                        <span class="customizeItemsText">
                          {{ $t('message.pages.customizeModal.expiry') }}
                          {{ getPayDate }}
                        </span>
                      </v-col>
                      <v-col cols="5" class="d-flex justify-end">
                        <span class="customizeItemsText">
                          {{
                            $t('message.pages.customizeModal.proporcionalValue')
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
              <v-card height="79px" width="100%" color="newBackground" flat>
                <v-row
                  no-gutters
                  justify="center"
                  align="center"
                  class="fill-height"
                >
                  <v-col cols="7">
                    <span class="cartBenefitsText typeText2--text">
                      <b>{{ $t('message.pages.customizeModal.nextCycles') }}</b>
                    </span>
                  </v-col>
                  <v-col cols="5" class="d-flex justify-end">
                    <span class="cartBenefitsText primary--text">
                      {{
                        prorateObjects.length > 1
                          ? sumCycleValues(withoutProrateLines).toLocaleString(
                              currencyLocale,
                              {
                                style: 'currency',
                                currency: currency,
                              }
                            )
                          : (prorateResponse.amount_due / 100).toLocaleString(
                              currencyLocale,
                              {
                                style: 'currency',
                                currency: currency,
                              }
                            )
                      }}/{{ $t('message.month') }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12">
            <span>{{ $t('message.pages.customizeModal.pricingWarning') }}</span>
          </v-col>
        </v-card-text>
        <!-- actions -->
        <v-card-actions class="px-8 py-6">
          <v-row no-gutters justify="center" align="center"> </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InvoiceDetails',
  components: {},
  data: () => ({
    open: false,
    prorateData: null,
    moreDetails: false,
    prorateResponse: {},
    prorateLines: [],
    prorateObjects: [],
    prorateDiscount: null,
    withoutProrateLines: [],
    currency: 'brl',
    currencyLocale: 'pt-BR',
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    getPayDate() {
      return this.getDateThroughTimeStamp(this.getPayTimeStamp)
    },
    getPayTimeStamp() {
      if (this.prorateObjects[this.prorateObjects.length - 1].end) {
        return this.prorateObjects[this.prorateObjects.length - 1].end
      }
      if (
        !this.prorateResponse.next_payment_attempt &&
        this.prorateResponse.lines
      ) {
        return this.prorateResponse.period.end
      } else {
        return this.prorateResponse.next_payment_attempt
      }
    },
  },
  mounted() {
    this.$root.$on('openInvoiceDetails', (data) => {
      this.open = true
      this.prorateData = data
      this.fixProrateData()
      this.setCurrencyConfig()
    })
  },
  beforeDestroy() {
    this.$root.$off('openInvoiceDetails')
  },
  methods: {
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    replaceKeywords(description) {
      if (
        (description.includes('Live Adicional') &&
          description.includes('(Pós)')) ||
        (description.includes('Additional live') &&
          description.includes('(Post)'))
      ) {
        description = description.replace(/\bmês\b|\bmonth\b/g, 'min')
      }
      return description
    },
    sumCycleValues(cycleLines) {
      let sum = cycleLines.reduce((acc, line) => acc + line.amount, 0)
      sum = sum - this.prorateResponse.referral_balance
      return sum / 100
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    fixProrateData() {
      let infoData = this.prorateData
      this.prorateResponse = infoData
      this.prorateLines = infoData.lines
      this.prorateDiscount = infoData.discount

      let prorateObjectsArray = []
      let prorateNextMonthLines = []
      for (let i = 0; i < this.prorateLines.length; i++) {
        let line = this.prorateLines[i]
        const conditions = [
          'Remaining',
          'restante',
          'Tempo não utilizado',
          'Não utilizado',
          'Unused time',
        ]
        if (!conditions.some((el) => line.description.includes(el))) {
          prorateNextMonthLines.push(line)
        }
        this.withoutProrateLines = prorateNextMonthLines
        if (!line.quantity) {
          continue
        }
        let findLine = prorateObjectsArray.find(
          (el) =>
            new Date(el.start * 1000).getDate() ===
              new Date(line.period.start * 1000).getDate() &&
            new Date(el.start * 1000).getMonth() ===
              new Date(line.period.start * 1000).getMonth() &&
            el.end === line.period.end
        )
        if (findLine) {
          let foundLineIndex = prorateObjectsArray.indexOf(findLine)
          prorateObjectsArray[foundLineIndex].objects.push(line)
        } else {
          let objects = []
          objects.push(line)
          prorateObjectsArray.push({
            start: line.period.start,
            end: line.period.end,
            objects,
          })
        }
      }
      prorateObjectsArray = prorateObjectsArray.sort((a, b) => {
        return a.end < b.end ? 1 : -1
      })
      this.prorateObjects = prorateObjectsArray.reverse()
    },
    getDateThroughTimeStamp(date) {
      let locale = this.getLocale()
      let options = {
        month: '2-digit',
        year: '2-digit',
        day: '2-digit',
      }
      return String(
        new Date(date * 1000).toLocaleString(locale, options).slice(0, 3) +
          new Date(date * 1000).toLocaleString(locale, options).slice(3, 6) +
          new Date(date * 1000).toLocaleString(locale, options).slice(6, 10)
      )
    },
    timeConverter(timestamp) {
      let a = new Date(timestamp * 1000)
      let locale = this.getLocale().toLowerCase()
      let months
      if (locale === 'en-us') {
        months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ]
      } else {
        months = [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Maio',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ]
      }
      let month = months[a.getMonth()]
      let date = a.getDate()
      let time = month + ' ' + date
      return time.toUpperCase()
    },
    getProhataLabel({ end }) {
      if (this.isCurrentMonth({ end })) return 'current'
      if (this.isNextMonth({ end })) return 'next'
      return false
    },
    isCurrentMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth()
      )
    },
    isNextMonth({ end }) {
      const dateObject = new Date(end * 1000)
      return (
        dateObject.getMonth() ===
        new Date(this.getPayTimeStamp * 1000).getMonth() + 1
      )
    },
    handleClose() {
      this.open = false
    },
    handleMoreDetails() {
      this.moreDetails = true
    },
    backToMain() {
      this.moreDetails = false
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 18px;
}
.columnTitle {
  font-weight: 400;
  font-size: 12px;
}
.columnRow {
  font-weight: 400;
  font-size: 16px;
}
.footerText {
  font-weight: 400;
  font-size: 14px;
}
.priceText {
  font-weight: 400;
  font-size: 16px;
  color: var(--v-brand-darken1);
}
.detailsText {
  font-weight: 400;
  font-size: 14px;
  color: var(--v-brand-darken1);
  cursor: pointer;
}
.cartPlanText {
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
}
.text--current-month {
  text-transform: uppercase;
}

.text--month-listing {
  background: var(--v-progressBar-lighten1);
}

.text--month-listing--dark {
  background: #60606038;
}

.border-bottom--gray {
  border-bottom: 1px solid #cdcdcd;
}

.bg-dark,
.theme--dark {
  .priceText,
  .detailsText {
    color: #70a5f2;
  }
}
</style>
